import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import * as services from "../api/services"
import { RECEIPT_COMPELLING_EVIDENCE_SLICE_NAME as SLICE_NAME } from "./compelling-evidence.constants"

export const getCompellingEvidenceState = createAsyncThunk(
  `${SLICE_NAME}/get_state`,
  async (businessId, { dispatch, rejectWithValue }) => {
    const response = await services.getCompellingEvidenceState({
      business_account_id: businessId
    })

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCompellingEvidenceCases = createAsyncThunk(
  `${SLICE_NAME}/get_cases`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCompellingEvidenceCases(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCompellingEvidenceCase = createAsyncThunk(
  `${SLICE_NAME}/get_case`,
  async ({ id, businessId }, { dispatch, rejectWithValue }) => {
    const response = await services.getCompellingEvidenceCase({
      id,
      business_account_id: businessId
    })
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCompellingEvidenceKpi = createAsyncThunk(
  `${SLICE_NAME}/get_kpi`,
  async ({ businessId, program }, { dispatch, rejectWithValue }) => {
    const response = await services.getCompellingEvidenceKpi({
      business_account_id: businessId,
      program: program || "all"
    })
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCompellingEvidenceExport = createAsyncThunk(
  `${SLICE_NAME}/get_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCompellingEvidenceExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// Not wired to the slice — dispatched only to consume via `.unwrap()` in the FAQ modal.
export const getCompellingEvidenceFaq = createAsyncThunk(
  `${SLICE_NAME}/get_faq`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getCompellingEvidenceFaq()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
